import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, LineClamp } from '../../global/commonStyle';

const Main = styled.div`
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-8);
  overflow: hidden;
`;

const Table = styled.table`
  background-color: var(--background-primary);
  width: 100%;
  border-collapse: collapse;
  border-radius: var(--border-radius-8);
  border-style: hidden;
  tr {
    border-top: 0.5px solid var(--border-primary);
    &:first-child {
      border-top: none;
      background: var(--background-tertiary);
      border-radius: var(--border-radius-8) var(--border-radius-8) var(--border-radius-0) var(--border-radius-0);
    }
    &:last-child {
      border-radius: var(--border-radius-0) var(--border-radius-0) var(--border-radius-8) var(--border-radius-8);
    }
    ${mobile_xl(css`
      ${FlexBetween}
      gap: var(--space-20);
      &:first-child {
        border-top: none;
        background-color: var(--background-primary);
        border-radius: var(--border-radius-8) var(--border-radius-8) var(--border-radius-0) var(--border-radius-0);
      }
    `)}
  }
  tr:not(:first-child):hover {
    cursor: pointer;
    background-color: var(--neutral-secondary);
    border-radius: var(--border-radius-0);
    width: 100%;
    tr:last-child {
      border-radius: var(--border-radius-0) var(--border-radius-0) var(--border-radius-8) var(--border-radius-8);
    }
    ${mobile_xl(css`
      ${FlexBetween}
      gap: var(--space-20);
      background-color: transparent;
    `)}
  }
  tr.active {
    background-color: var(--neutral-secondary);
    border-radius: var(--border-radius-4);
  }
  th {
    ${Typography.body_md_medium}
    color: var(--text-primary);
    padding: var(--space-10) var(--space-16) var(--space-10) var(--space-0);
    margin: var(--space-0);
    text-align: left;
    white-space: nowrap;
    &:first-child {
      padding: var(--space-10) var(--space-16);
    }
  }
  p {
    margin: var(--space-0);
  }
  .last {
    width: 24px;
    height: 24px;
    padding-right: var(--space-8);
  }
  td {
    ${Typography.body_md_medium}
    color: var(--text-primary);
    padding: var(--space-8) var(--space-16) var(--space-8) var(--space-0);
    margin: var(--space-0);
    text-align: left;
    ${mobile_xl(css`
      max-width: 312px;
    `)}
    &:first-child {
      padding: var(--space-8) var(--space-16);
      ${mobile_xl(css`
        padding-right: var(--space-0);
      `)}
    }
    &.second-column {
      white-space: nowrap;
      color: var(--text-secondary);
    }
    &.third-column {
      white-space: nowrap;
      color: var(--text-secondary);
    }
    &.forth-column {
      padding-right: var(--space-8);
      ${mobile_xl(css`
        height: -webkit-fill-available;
        padding-right: var(--space-12);
        ${AlignCenter}
      `)}
    }
  }
  .active-dropdown {
    background-color: var(--background-muted);
    border-radius: var(--border-radius-6);
  }
  .dropdown-hover:hover {
    background-color: var(--background-muted);
    ${mobile_xl(css`
      background-color: unset;
    `)}
  }
`;

const Icon = styled.div`
  width: 28px;
  height: 28px;
  .file-list-icon {
    path {
      stroke: var(--text-primary);
    }
  }
`;

const ResponsiveDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
`;

const DocumentTitle = styled.p`
  ${Typography.body_md_medium}
  color: var(--text-primary);
  margin: var(--space-0);
  text-align: left;
  ${LineClamp(1)}
  word-break: break-all;
  max-width: 596px;
`;

const DocCreated = styled.p`
  ${Typography.body_sm_medium}
  color: var(--text-secondary);
  margin: var(--space-0);
  ${LineClamp(1)}
  word-break: break-all;
`;

const First = styled.div`
  ${AlignCenter}
  gap: var(--space-12);
`;

const FileIconDiv = styled.div`
  position: relative;
  .file-text {
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 35%;
    left: 25%;
    width: 50%;
    font-weight: 700;
    color: var(--text-secondary);
  }
`;

export { Main, Table, Icon, First, FileIconDiv, ResponsiveDiv, DocumentTitle, DocCreated };
